export const state = {
  nextStatePlural: "Next states",
  currentState: "Current state",
  updateState: "Update state",
};
